import { Injectable } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';
import { ApiService } from '../../shared/services/core/api.service';
import { VoucherRedeemModel } from '../models/voucher-redeem.model';
import { LoggingService } from '../../shared/services/core/logging.service';
import { REDEMPTION_RESULT, VoucherStore } from '../state/voucher.store';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';
import { config } from '../../shared/config';
import { BalanceService } from '../../account/balance/balance.service';

@Injectable({
  providedIn: 'root',
})
export class VoucherService {
  constructor(
    private api: ApiService,
    private logService: LoggingService,
    private voucherStore: VoucherStore,
    private balanceService: BalanceService
  ) {}

  /**
   * Redeem voucher code (normal)
   * @param voucherCode the voucher code model
   */
  public redeemVoucher(voucherCode: VoucherRedeemModel): Observable<any> {
    this.logService.debug('Redeeming voucher', voucherCode);
    return this.api.post<VoucherRedeemModel>('vouchers/redeem', voucherCode);
  }

  /**
   * Redeem voucher code (normal)
   * @param voucher the voucher code model
   */
  public redeemVoucherUsingStore(voucher: VoucherRedeemModel): Observable<any> {
    this._setMessage(null);

    if (!voucher.VoucherCode) {
      this._setMessage(REDEMPTION_RESULT.EMPTY);
      return of(null);
    }
    this.logService.debug('Redeeming voucher', voucher);

    this.voucherStore.setLoading(true);
    return this.api.post<VoucherRedeemModel>('vouchers/redeem', voucher).pipe(
      switchMap((voucher) =>
        this.balanceService
          .fetchBalance(config.purseConfig.virtualLoyalty)
          .pipe(tap(() => this.voucherStore.update({ voucher, resultMessage: REDEMPTION_RESULT.SUCCESS, error: null })))
      ),
      catchError((err) => {
        this.voucherStore.update({ resultMessage: err.error.Code, error: err.error });
        return EMPTY;
      }),
      finalize(() => this.voucherStore.setLoading(false))
    );
  }

  /**
   * Redeem voucher code location (when same code for different locations)
   * @param voucherCode the voucher code model
   */
  public redeemVoucherLocation(voucherCode: VoucherRedeemModel): Observable<any> {
    this.logService.debug('Redeeming location voucher', voucherCode);
    return this.api.post<VoucherRedeemModel>('vouchers/redeemLocation', voucherCode);
  }

  private _setMessage(resultMessage: REDEMPTION_RESULT | null): void {
    this.voucherStore.update({ resultMessage });
  }
}
